// extracted by css-extract-rspack-plugin
export default {"pageLoader":"pageLoader__z2COE","pageLoader_sticky":"pageLoader_sticky__LkSxd"};